import { APP_TO_WEB, msgData, requestApp, WEB_TO_APP } from "common/webview";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { deviceAtom } from "store/deviceStore";
import { insetAtom } from "store/uiStore";

export const useWebview = () => {
    const setInset = useSetAtom(insetAtom);
    const setDevice = useSetAtom(deviceAtom);

    if (window.ReactNativeWebView) {
        // 앱으로 접속했을 경우 console함수 재정의
        console.log = function (...props) {
            window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'LOGS', data: props }));
        };
        console.error = function (...props) {
            window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'ERROR_LOGS', data: props }));
        };
    }

    //앱에서 전송한 메세지 수신하는 이벤트
    const onMessage = (e: MessageEvent) => {
        const { type, data } = msgData(e);
        switch (type) {
            case APP_TO_WEB.INSET_INFO:
                setInset({
                    statusBarHeight: data.status_bar_height,
                    navigationBarHeight: data.navigation_bar_height
                })
                break;
            case APP_TO_WEB.DEVICE_INFO :
                setDevice(data)
                break;
                
            default:
                break;
        }
    }


    useEffect(() => {
        //웹뷰일 경우 메세지를 받을 수 있는 listener추가
        // if (window.ReactNativeWebView) {
            window.addEventListener('message', onMessage); //iOS
            (document as any).addEventListener('message', onMessage); //Android
            console.log("Ready")
            requestApp(WEB_TO_APP.MSG_READY);
        // }
        return () => {
            //웹뷰일 경우 listener제거
            if (window.ReactNativeWebView) {
                window.removeEventListener('message', onMessage); //iOS
                (document as any).removeEventListener('message', onMessage); //Android
            }
        }
    }, [])
}